var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetCrystal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 58.784 36.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15859",
    "data-name": "Group 15859",
    transform: "translate(-601.736 -4467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Show",
    d: "M29.392,60.74C10.162,60.74.628,43.976.231,43.262a1.837,1.837,0,0,1,0-1.785C.628,40.765,10.162,24,29.392,24S58.157,40.765,58.553,41.478a1.837,1.837,0,0,1,0,1.785C58.157,43.976,48.622,60.74,29.392,60.74ZM4,42.367c2.185,3.312,10.764,14.7,25.393,14.7,14.675,0,23.217-11.378,25.393-14.693-2.185-3.312-10.764-14.7-25.393-14.7C14.717,27.674,6.176,39.052,4,42.367Z",
    transform: "translate(601.736 4443)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Show-2",
    "data-name": "Show",
    d: "M31.187,54.11A11.022,11.022,0,1,1,42.209,43.088,11.034,11.034,0,0,1,31.187,54.11Zm0-18.37a7.348,7.348,0,1,0,7.348,7.348A7.357,7.357,0,0,0,31.187,35.74Z",
    transform: "translate(599.941 4442.282)",
    fill: "#96006b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetCrystal);
export default __webpack_public_path__ + "static/media/GetCrystal.263f617d2ae53ea50b96ac0d4ecae9b7.svg";
export { ForwardRef as ReactComponent };